import React from "react"
import { useAnsweredFormOverviewContext } from "contexts/AnsweredFormOverviewContext"
import { questionShape } from "utils/propTypeShapes"
import {
  DATE_TYPE, LOCATION_TYPE, MULTI_ENTRIES_TYPE, MULTI_SELECT_TYPE, MULTI_USER_SELECT_TYPE, NOTE_ANSWER_TYPE, TIME_TYPE,
} from "views/Forms/FormElementTypes"
import Answer from "./Answer"
import DateAnswer from "./DateAnswer"
import LocationAnswer from "./LocationAnswer"
import MultiEntryAnswer from "./MultiEntryAnswer"
import MultiSelectAnswer from "./MultiSelectAnswer"
import NoteAnswer from "./NoteAnswer/NoteAnswer"
import TimeAnswer from "./TimeAnswer"
import UsersAnswer from "./UsersAnswer"

const answerComponents = {
  [DATE_TYPE]: DateAnswer,
  [LOCATION_TYPE]: LocationAnswer,
  [MULTI_ENTRIES_TYPE]: MultiEntryAnswer,
  [MULTI_SELECT_TYPE]: MultiSelectAnswer,
  [MULTI_USER_SELECT_TYPE]: UsersAnswer,
  [NOTE_ANSWER_TYPE]: NoteAnswer,
  [TIME_TYPE]: TimeAnswer,
}

export const answerComponent = (questionType) => answerComponents[questionType] || Answer

const AnsweredFormOverviewQuestionAnswer = ({ question }) => {
  const { type: questionType, uuid: questionUuid } = question
  const { answer, isNewQuestion } = useAnsweredFormOverviewContext()

  const AnswerComponent = answerComponent(questionType)

  return (
    <AnswerComponent isNewQuestion={isNewQuestion(questionUuid)} question={question} rawAnswer={answer(questionUuid)} />
  )
}

AnsweredFormOverviewQuestionAnswer.propTypes = {
  question: questionShape.isRequired,
}

export default AnsweredFormOverviewQuestionAnswer
